import { Routes } from "src/routes";
import { typeCheckAppModule } from "src/utils";
import { InvestorClubPage } from "./InvestorClubPage";

export const investorClub = typeCheckAppModule({
    NAME: "investorClub",
    Container: InvestorClubPage,
    route: Routes.investorClub,
});
